export enum ReportNameEnum {
  DnevniPlanEmitovanja = 'DnevniPlanEmitovanja',
  SOKOJ = 'SOKOJ',
  OFPS = 'OFPS',
  Glink = 'Glink',
  Realizacija = 'Realizacija',
  PGP = 'PGP',
  PrihodPoEmisijama = 'PrihodPoEmisijama',
}



// WEBPACK FOOTER //
// ./src/app/enums/report-name.enum.ts